<form (keydown.enter)="$event.preventDefault()" (ngSubmit)="submit()" [formGroup]="standingOrderForm">
    <div id="standingOrderForm" fxLayout="column" fxLayoutAlign="start center">
        <dx-load-panel
            shadingColor="rgba(0,0,0,0.4)"
            [(visible)]="isLoading"
            [showIndicator]="true"
            [showPane]="true"
            [shading]="true"
            [closeOnOutsideClick]="false">
        </dx-load-panel>
        <div class="content-block dx-card responsive-paddings ocl-top-container" style="width: 95vw">
            <dx-toolbar id="navigation-header" style=" padding-right: 16px !important;">
                <dxi-item location="before">
                    <h3 class="padding-block margin-h3" *ngIf="standingOrderId === undefined || standingOrderId === null">New Standing Order</h3>
                    <h3 class="padding-block margin-h3" *ngIf="standingOrderId !== undefined && standingOrderId !== null">Edit Standing Order</h3>
                </dxi-item>
                <dxi-item location="after">
                    <dx-button
                        [text]="'Save'"
                        [disabled]="!canSave()"
                        (keyup.enter)="preventDefault($event)"
                        [useSubmitBehavior]="true"
                    ></dx-button>
                </dxi-item>
            </dx-toolbar>
            <app-patient-physician-header
                [patientControl]="convertToFormControl(standingOrderForm.get('patient'))"
                [physicianControl]="convertToFormControl(standingOrderForm.get('physician'))">
            </app-patient-physician-header>
        </div>
        <div class="content-block dx-card responsive-paddings ocl-bottom-container" style="width: 95vw">
            <div fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="space-between">
                <div fxLayout="column" fxFlex="50">
                    <div style="height: auto !important; padding-bottom: 0 !important;">
                        <div fxLayout="column" style="padding-left: 16px !important; padding-right: 16px !important; margin-bottom: 0 !important; height: auto !important;">
                            <app-loading-header [loading]="pickerDataSource === undefined && IsPatientSelected">Test Selection</app-loading-header>
                            <div fxLayout="row" fxLayoutAlign="space-between">
                                <dx-drop-down-box
                                    #testDropdown
                                    [(value)]="pickerSelectedTestsKey"
                                    valueExpr="id"
                                    [disabled]="pickerDataSource === undefined || (standingOrderId !== undefined && standingOrderId !== null)"
                                    [displayExpr]="displayTestExpresion"
                                    placeholder="Select tests..."
                                    [showClearButton]="true"
                                    [dataSource]="pickerDataSource.value"
                                    style="width: 100%"
                                    (onOpened)="resizePickerDropDown()">
                                    <div *dxTemplate="let data of 'content'" id="testsPickerContainer">
                                        <dx-data-grid
                                            #dropDownGrid
                                            [dataSource]="pickerDataSource.value"
                                            [columns]="['code', 'name', 'alternateNames']"
                                            [selection]="{ mode: 'single' }"
                                            [hoverStateEnabled]="true"
                                            [paging]="{ enabled: true, pageSize: 10 }"
                                            [filterRow]="{ visible: true }"
                                            [scrolling]="{ mode: 'infinite' }"
                                            [showRowLines]="true"
                                            [highlightChanges]="true"
                                            [allowColumnResizing]="true"
                                            [wordWrapEnabled]="true"
                                            style="min-width: 100px!important;"
                                            [showBorders]="true"
                                            [columnAutoWidth]="true"
                                            [height]="'100%'"
                                            [width]="'100%'"
                                            (onSelectionChanged)="testSelectionChanged()"
                                            [(selectedRowKeys)]="pickerSelectedTestsKey"
                                            [searchPanel]="{ visible: !isPhoneOrTablet, width: 240, placeholder: 'Search...'}"
                                            [columnHidingEnabled]="isPhone || isTablet">
                                        </dx-data-grid>
                                    </div>
                                </dx-drop-down-box>
                            </div>
                        </div>
                        <div fxLayout="column">
                            <h4 style="padding-left: 16px">Scheduler</h4>
                            <div class="dx-card ocl-bottom-container" style="margin: 0 16px 16px 16px; padding-bottom: 0 !important;">
                                <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="space-between" style="padding: 16px !important;"
                                    [ngStyle.xs]="{'padding-left': '4px', 'padding-right': '4px'}">
                                    <div fxLayout="column" fxLayoutAlign="space-between" fxFlex="48" fxFlex.sm="55">
                                        <div class="dx-field">
                                            <div class="dx-field-label">Repeat</div>
                                            <div class="dx-field-value">
                                                <dx-select-box
                                                    [dataSource]="repeatDataSource"
                                                    displayExpr="text"
                                                    valueExpr="key"
                                                    [formControl]="convertToFormControl(standingOrderForm.get('type'))"
                                                    (onSelectionChanged)="onRepeatChange($event)">
                                                    <dx-validator>
                                                        <dxi-validation-rule type="required"></dxi-validation-rule>
                                                    </dx-validator>
                                                </dx-select-box>
                                            </div>
                                        </div>
                                        <div class="dx-field">
                                            <div class="dx-field-label">Repeat Every</div>
                                            <div fxLayout="row" fxLayoutAlign="space-between">
                                                <div class="dx-field-value" fxFlex="50">
                                                    <dx-number-box
                                                        [value]="1"
                                                        [min]="1"
                                                        [showSpinButtons]="true"
                                                        [formControl]="convertToFormControl(standingOrderForm.get('repeatEvery'))">
                                                    </dx-number-box>
                                                </div>
                                                <div class="dx-field-label" fxFlex="45"> {{ repeatType }} </div>
                                            </div>
                                        </div>
                                        <div class="dx-field" *ngIf="standingOrderForm.get('type')?.value === 'MonthlyByDay'">
                                            <div class="dx-field-label">On</div>
                                            <div class="dx-field-value">
                                                <dx-select-box
                                                    [dataSource]="['First', 'Second', 'Third', 'Fourth', 'Last']"
                                                    [formControl]="convertToFormControl(standingOrderForm.get('repeatOnMonthlyByDay'))"
                                                    (onSelectionChanged)="onRepeatChange($event)">
                                                    <dx-validator>
                                                        <dxi-validation-rule type="required"></dxi-validation-rule>
                                                    </dx-validator>
                                                </dx-select-box>
                                            </div>
                                        </div>
                                        <div class="dx-field" *ngIf="standingOrderForm.get('type')?.value === 'Week' || standingOrderForm.get('type')?.value === 'MonthlyByDay'">
                                            <div class="dx-field-label">On Days of Week</div>
                                            <div fxLayout="row">
                                                <div class="dx-field-value">
                                                    <dx-button-group
                                                        [items]="[{
                                                            text: 'Sun'
                                                        }, {
                                                            text: 'Mon'
                                                        }, {
                                                            text: 'Tue'
                                                        }, {
                                                            text: 'Wed'
                                                        }, {
                                                            text: 'Thu'
                                                        }, {
                                                            text: 'Fri'
                                                        }, {
                                                            text: 'Sat'
                                                        }]"
                                                        keyExpr="text"
                                                        stylingMode="outlined"
                                                        selectionMode="multiple"
                                                        [(selectedItems)]="dayOfWeek"
                                                        (onSelectionChanged)="dayOfWeekChange($event)">
                                                    </dx-button-group>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="dx-field" *ngIf="standingOrderForm.get('type')?.value === 'MonthlyByDate'">
                                            <div class="dx-field-label">On Days of Month</div>
                                            <div class="dx-field-value">
                                                <dx-tag-box
                                                    [items]="repeatOnMonthlyByDateDataSource"
                                                    [showSelectionControls]="true"
                                                    [value]="repeatOnMonthlyByDateSelectedEdit"
                                                    [(selectedItems)]="repeatOnMonthlyByDateSelected">
                                                </dx-tag-box>
                                            </div>
                                        </div>
                                        <div class="dx-field">
                                            <div class="dx-field-label">End Repeat</div>
                                            <div fxLayout="row">
                                                <div class="dx-field-value">
                                                    <dx-radio-group
                                                        [items]="['Never', 'After', 'On']"
                                                        itemTemplate="radio"
                                                        (valueChange)="endTypeChange($event)"
                                                        [formControl]="convertToFormControl(standingOrderForm.get('endType'))">
                                                        <div class="radio" *dxTemplate="let data of 'radio'">
                                                            <div fxLayout="row" fxLayoutAlign="space-between" *ngIf="data === 'Never'" style="height: 28px !important;">
                                                                <div fxFlex="25">
                                                                    <span style="vertical-align: sub"> {{ data }} </span>
                                                                </div>
                                                            </div>
                                                            <div fxLayout="row" fxLayoutAlign="space-between" *ngIf="data === 'After'" style="height: 28px !important;">
                                                                <div fxFlex="25" fxFlex.lt-md="15">
                                                                    <span style="vertical-align: sub; width: 100%"> {{ data }} </span>
                                                                </div>
                                                                <div fxLayout="row" fxLayoutAlign="space-between" fxFlex="75" fxFlex.lt-md="85">
                                                                    <div class="dx-field-value" fxFlex="40" fxFlex.lt-md="50">
                                                                        <dx-number-box
                                                                            [value]="1"
                                                                            [min]="1"
                                                                            [showSpinButtons]="true"
                                                                            [formControl]="convertToFormControl(standingOrderForm.get('after'))"
                                                                            [disabled]="this.standingOrderForm.get('endType')?.value !== 'After'">
                                                                        </dx-number-box>
                                                                    </div>
                                                                    <div class="dx-field-label" fxFlex="55" fxFlex.lt-md="45"> ocurrence(s) </div>
                                                                </div>
                                                            </div>
                                                            <div fxLayout="row" fxLayoutAlign="space-between" *ngIf="data === 'On'" style="height: 28px !important;">
                                                                <div fxFlex="25" fxFlex.lt-md="15">
                                                                    <span style="vertical-align: sub; width: 100%"> {{ data }} </span>
                                                                </div>
                                                                <div class="dx-field-value" fxFlex="75" fxFlex.lt-md="85">
                                                                    <dx-date-box
                                                                        [formControl]="convertToFormControl(standingOrderForm.get('endDate'))"
                                                                        [disabled]="this.standingOrderForm.get('endType')?.value !== 'On'"
                                                                        type="datetime"
                                                                        [min]="startDate"
                                                                        [dateSerializationFormat]="'yyyy-MM-ddTHH:mm:ss'"
                                                                        (valueChange)="endDateChange($event)"
                                                                        (onContentReady)="onDateReady($event)">
                                                                    </dx-date-box>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </dx-radio-group>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div fxLayout="column" fxFlex="48" fxFlex.sm="41">
                                        <div class="dx-field">
                                            <div class="dx-field-label">Start Date</div>
                                            <div class="dx-field-value">
                                                <dx-date-box
                                                    [formControl]="convertToFormControl(standingOrderForm.get('startDate'))"
                                                    type="datetime"
                                                    [max]="endDate"
                                                    [dateSerializationFormat]="'yyyy-MM-ddTHH:mm:ss'"
                                                    (valueChange)="startDateChange($event)"
                                                    (onContentReady)="onDateReady($event)">
                                                </dx-date-box>
                                            </div>
                                        </div>
                                        <div class="dx-field">
                                            <div class="dx-field-label">Generate in Advance</div>
                                            <div fxLayout="row" fxLayoutAlign="space-between">
                                                <div class="dx-field-value" fxFlex="50">
                                                    <dx-number-box
                                                        [value]="initialValueGenerateInAdvance"
                                                        [min]="1"
                                                        [showSpinButtons]="true"
                                                        [formControl]="convertToFormControl(standingOrderForm.get('generateInAdvance'))">
                                                    </dx-number-box>
                                                </div>
                                                <div class="dx-field-label" fxFlex="45"> {{ standingOrderForm.get('type')?.value === 'Minute' ? 'hour(s)' : repeatType }} </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div fxFlex="50" style="height: auto !important;" [ngStyle.lt-md]="{height: '300px'}">
                   <!-- <app-glass-with-options
                        #diagnosesGlass
                        [textSelectorPlaceholder]="'Code'"
                        [textSelectorExpr]="'code'"
                        [localStorageName]="'standingOrderDiagnoses'"
                        [label]="'Diagnoses'"
                        [selectedItems]="selectedDiagnosisOnlyForEdit"
                        [optionalConfig]="{
                                button: {
                                    text: 'Patient Diagnoses',
                                    icon: 'user',
                                    disabled: !IsPatientSelected,
                                    filterExpr: filter
                                }
                            }"
                        [disabled]="!IsPatientSelected"
                        [source]="diagnoseService.getAllDiagnoses()"
                        [keyExpr]="'id'"
                        [columns]="diagnosesFormRelationColumns"
                        (selectionChanged)="diagnoseChanged($event)">
                    </app-glass-with-options>-->
                    <app-form-relation-glass
                        [textSelectorPlaceholder]="'Code'"
                        [textSelectorExpr]="'code'"
                        [maxHeight]="450"
                        [label]="'Diagnoses'"
                        [disabled]="isLoading"
                        [dataSource]="diagnosisDataSource.value"
                        [searchEnabled]="true"
                        [searchService]="diagnosisService"
                        [keyExpr]="'id'"
                        [optionalConfig]="{
                            button: {
                                text: 'Patient Diagnoses',
                                icon: 'user',
                                disabled: !IsPatientSelected,
                                filterExpr: undefined
                            }
                        }"
                        [columns]="diagnosesFormRelationColumns"
                        [alternateDataSource]="alternateDiagnosisDataSource.value"
                        [control]="convertToFormControl(standingOrderForm.get('diagnoses'))"
                    ></app-form-relation-glass>
                </div>
            </div>
            <div style="height: 300px" [ngStyle.xs]="{height: '400px'}">
                <app-comments-control
                    [label]="'Comments'"
                    [disabled]="!IsPatientSelected"
                    [control]="standingOrderForm.get('comments')">
                </app-comments-control>
            </div>
        </div>
    </div>
</form>
<app-standing-order-done-dialog
    [mode]="mode"
    [popupVisible]="standingOrderDoneVisible"
    [patientId]="standingOrderForm.get('patient')?.value !== null ? standingOrderForm.get('patient')?.value?.id : -1">
</app-standing-order-done-dialog>
